// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"382f1d5b","356":"d41676a1","438":"e1432996","465":"2c51d7d9","538":"622add16","912":"dc7d6586","954":"658680f7"}[chunkId] + ".chunk.js";
};